import { useQuery } from '@tanstack/react-query';
import type { ToolExecutionHar } from '@terra/shared-contracts-tracker';

export function useHarById({
  toolExecutionHarId,
  fetchHarById,
  enabled = true,
}: {
  toolExecutionHarId: string;
  fetchHarById: ((id: string) => Promise<ToolExecutionHar | null>) | undefined;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ['toolExecutionHar', toolExecutionHarId],
    queryFn: () => fetchHarById!(toolExecutionHarId),
    enabled: enabled && !!toolExecutionHarId && !!fetchHarById,
  });
}
